import { render, staticRenderFns } from "./General.vue?vue&type=template&id=c6ea29fe&scoped=true&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.vue?vue&type=style&index=0&id=c6ea29fe&lang=scss&scoped=true&"
import style1 from "./General.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ea29fe",
  null
  
)

export default component.exports